module.exports = __webpack_public_path__ + "img/banner01.e5126c76.png";